export const LogoMark = ({ size = 34, testid = "logo-mark" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    data-testid={testid}
  >
    <path
      d="M9 30L20 9L31 30"
      stroke="#16D69A"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M14.5 22.5H25.5" stroke="#388BFF" strokeWidth="2.5" strokeLinecap="round" />
    <circle cx="20" cy="14.5" r="2.6" fill="#16D69A" />
    <path d="M11 32.5H29" stroke="#F5F7F8" strokeOpacity="0.35" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const Logo = ({ compact = false }) => (
  <span className="inline-flex items-center gap-2.5" data-testid="brand-logo">
    <LogoMark />
    {!compact && (
      <span className="font-display text-lg font-semibold tracking-tight text-brand-snow">
        A2Z <span className="font-normal text-brand-mist">Rankings</span>
      </span>
    )}
  </span>
);
